import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { FormControl, MenuItem, Select, Box, IconButton, Tooltip, Typography } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import GetJobId from "../../../_utilities/GetJobId";
import {
  getProjectJobsAsync,
  addAssociateProjectJobsAsync,
  addAssociateProjectJobsStartReducer,
  deleteProjectJobsAsync,
  deleteProjectJobsStartReducer,
} from "../../../_redux/_services/ProjectsSlice";
import * as _props from "../../../_redux/_services/JobPostingSlice";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import { resetSelectedJobPosting, setSelectedJobPosting } from "../../../_redux/SelectedJobPostingSlice";
import { updateNextPath } from "../../../_redux/SelectedNextPath";
import { toggleSidebar } from "../../../_redux/Uislice";
import AssociateCards from "../../../components/AssociateCards/AssociateCards";
import ApplicantsFooter from "../../../components/ApplicantsFooter/ApplicantsFooter";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import WarningPopup from "../../../components/WarningPopup/WarningPopup";
import { customFieldsAsync } from "../../../_redux/_services/UserManagerSlice";
import { defaultApplicantsData } from "../../../_utilities/defaultfieldsModel";
import { GetUserId } from "../../../_utilities/getUserInfo";
import Pagination from "../../../components/DynamicTable/Pagination";
import "./AddJobsToProjects.css";
import FloatingMenu from "../../../components/FloatingMenu/FloatingMenu";
import { JobsAddfloatingMenuOptions } from "../../../constants/floatingMenuConstants";
import JobpostingDetailsTabs from "../../JobPostings_New_UI/JobpostingDetails/JobpostingDetailsTabs/JobpostingDetailsTabs";

const initalState = { data: null, message: "", isloader: true };

const AddJobsToProjects = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getJobCode = GetJobId();

  const [jobs, setJobs] = useState([]);
  const [panelMode, setPanelMode] = useState(null); // 'ADD_JOB'
  const [showJobDetails, setShowJobDetails] = useState(false);
  const [isResetTabs, setIsResetTabs] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const CARDS_PER_PAGE = 12;

  const [selectedJobIds, setSelectedJobIds] = useState([]);
  const [tooltipCardId, setTooltipCardId] = useState(null);
  const [showSelectAllTip, setShowSelectAllTip] = useState(
    sessionStorage.getItem("hasSeenSelectAllProjectJobsTip") !== "true",
  );
  const clickTimer = useRef(null);

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  const nextPathValue = useSelector((state) => state.SeletedNextPath?.value);
  const { storedJobPostingId, aditionalState } = useSelector((state) => state.SelectedJobPosting);

  useEffect(() => {
    if (!storedJobPostingId || nextPathValue === "null") {
      setShowJobDetails(false);
    } else if (storedJobPostingId && aditionalState) {
      dispatch(updateNextPath(aditionalState));
      setShowJobDetails(true);
      handleTooltipDismiss();
      navigate(
        `/ats/layout/projects/jobs/${getJobCode}?projectJobId=${storedJobPostingId}`
      );
    }
  }, [storedJobPostingId, aditionalState, nextPathValue, getJobCode, navigate]);

  const handleTooltipDismiss = () => {
    setShowSelectAllTip(false);
    setTooltipCardId(null);
    sessionStorage.setItem("hasSeenSelectAllProjectJobsTip", "true");
  };

  const handleCheckboxChange = (job, isChecked) => {
    if (isChecked) {
      setSelectedJobIds((prev) => [...prev, job]);
    } else {
      setSelectedJobIds((prev) => prev.filter((item) => item.id !== job.id));
    }
    setJobs((prevJobs) =>
      prevJobs.map((item) =>
        item.id === job.id ? { ...item, isChecked } : item,
      ),
    );
  };

  const handleSelectAll = (isChecked) => {
    const startIndex = (currentPage - 1) * CARDS_PER_PAGE;
    const endIndex = startIndex + CARDS_PER_PAGE;

    const updatedJobs = jobs.map((item, index) =>
      index >= startIndex && index < endIndex
        ? { ...item, isChecked }
        : item,
    );
    setJobs(updatedJobs);

    const currentPageJobs = updatedJobs.slice(startIndex, endIndex);

    if (isChecked) {
      const newSelected = [...selectedJobIds];
      currentPageJobs.forEach((item) => {
        if (!newSelected.some((x) => x.id === item.id)) {
          newSelected.push(item);
        }
      });
      setSelectedJobIds(newSelected);
    } else {
      const currentIds = currentPageJobs.map((item) => item.id);
      setSelectedJobIds((prev) =>
        prev.filter((item) => !currentIds.includes(item.id)),
      );
    }
    handleTooltipDismiss();
  };

  const projectJobsResponse = useSelector(
    (state) => state.GetProjectJobs?.data,
  );

  useEffect(() => {
    if (getJobCode) {
      fetchProjectJobs();
    }
  }, [getJobCode]);

  const fetchProjectJobs = () => {
    const payload = {
      id: getJobCode,
    };
    dispatch(getProjectJobsAsync(payload));
  };

  useEffect(() => {
    if (
      projectJobsResponse !== null &&
      Array.isArray(projectJobsResponse?.rows)
    ) {
      const fetchedJobs = projectJobsResponse.rows.map((j) => ({
        ...j,
        isChecked: false,
      }));
      setJobs(fetchedJobs);

      const maxPage = Math.ceil(fetchedJobs.length / CARDS_PER_PAGE);
      setCurrentPage((prevPage) => {
        if (maxPage > 0 && prevPage > maxPage) {
          return maxPage;
        }
        return prevPage;
      });
    } else if (projectJobsResponse === null) {
      setJobs([]);
      setCurrentPage(1);
    }
  }, [projectJobsResponse]);

  const getPostedDaysAgo = (dateStr) => {
    if (!dateStr) return "";
    const created = new Date(dateStr);
    const now = new Date();
    const diffTime = Math.abs(now - created);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return "posted today";
    if (diffDays === 1) return "posted 1 day ago";
    return `posted ${diffDays} days ago`;
  };

  const handleAddPanelOpen = () => {
    setPanelMode("ADD_JOB");
  };

  const handleJobCardClick = (job) => {
    dispatch(resetSelectedJobPosting());
    setIsResetTabs(true);
    dispatch(
      setSelectedJobPosting({
        storedJobPostingId: job.id,
        storedJobCode: job.jobCode,
        aditionalState: `${job.jobTitle || job.title || "Job"} (${job.jobCode})`,
      }),
    );
    dispatch(
      updateNextPath(`${job.jobTitle || job.title || "Job"} (${job.jobCode})`),
    );
    setShowJobDetails(true);
    handleTooltipDismiss();
  };

  const handleAddPanelClose = (pannel, load) => {
    setPanelMode(null);
    if (load === "refresh" || load === true) {
      fetchProjectJobs();
    }
  };

  const onReceivePropsHandler = (_status, type) => {
    if (type === "close" || _status === "close") {
      setShowJobDetails(false);
      dispatch(updateNextPath("null"));
      dispatch(toggleSidebar(false));
      navigate(location.pathname);
    } else if (_status === "deleted") {
      setShowJobDetails(false);
      dispatch(updateNextPath("null"));
      dispatch(toggleSidebar(false));
      fetchProjectJobs();
    } else if (_status === "changeAppliant") {
      fetchProjectJobs();
    }
  };

  const deleteResponse = useSelector((state) => state.DeleteProjectJobs?.data);
  const [deletePopupOpen, setDeletePopupOpen] = useState(false);

  useEffect(() => {
    if (deleteResponse === 200) {
      dispatch(deleteProjectJobsStartReducer());
      setSelectedJobIds([]);
      fetchProjectJobs();
    }
  }, [deleteResponse]);

  const handleDeleteJob = () => {
    const payload = {
      jobId: selectedJobIds.map((j) => j.id),
      projectId: Number(getJobCode),
    };
    dispatch(deleteProjectJobsAsync(payload));
    setDeletePopupOpen(false);
  };

  const onReceiveActionHandler = async (type, object) => {
    if (currentPage === 1 && tooltipCardId && showSelectAllTip) {
      handleTooltipDismiss();
    }
    if (type === "addJobs") {
      handleAddPanelOpen();
    } else if (type === "delete") {
      if (selectedJobIds && selectedJobIds.length > 0) {
        setDeletePopupOpen(true);
      } else {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Please select at least one Job",
          }),
        );
      }
    }
  };

  const addJobPanelObj = {
    title: "Add Job to this Project",
    description: "",
    bgImage: "",
  };

  // Since the backend handles pagination now, jobs array directly corresponds to the active page
  const paginatedJobs = jobs.slice(
    (currentPage - 1) * CARDS_PER_PAGE,
    currentPage * CARDS_PER_PAGE,
  );

  return (
    <div className="client-jobs-page">
      {!showJobDetails ? (
        <>
          <div className="addWrapper">
            <FloatingMenu
              floatingMenuOptions={JobsAddfloatingMenuOptions}
              onReceiveActionHandler={onReceiveActionHandler}
              storedTheme={storedTheme}
            />
          </div>

          {/* Jobs grid - when data exists */}
          {paginatedJobs && paginatedJobs.length > 0 ? (
            <>
              <div className="jobsGrid">
                {paginatedJobs.map((job, index) => (
                  <div
                    className="jobCard cursor-pointer"
                    key={job.id || index}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ width: "calc(100% - 41px)" }} onClick={() => handleJobCardClick(job)}>
                        <div className="jobCardHeader">
                          <h4>
                            {job.jobTitle || "Untitled"}{" "}
                            {job.jobCode ? `(${job.jobCode})` : ""}
                          </h4>
                        </div>
                      </div>
                      <Box className="header-icons">
                        <Tooltip
                          placement="bottom-start"
                          open={currentPage === 1 && tooltipCardId === job.id && showSelectAllTip}
                          PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [5, -20],
                                },
                              },
                            ],
                          }}
                          title={
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 1,
                              }}
                            >
                              <InfoOutlinedIcon sx={{ fontSize: 18, mt: "2px" }} />
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  lineHeight: 1.4,
                                  flex: 1,
                                }}
                              >
                                <b style={{ color: "#fff" }}>Tip:</b> Double-click to select all applicants
                              </Typography>

                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleTooltipDismiss();
                                }}
                                sx={{
                                  color: "#fff",
                                  p: "2px",
                                  mt: "-4px",
                                }}
                              >
                                <CloseIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                            </Box>
                          }
                          componentsProps={{
                            tooltip: {
                              sx: {
                                bgcolor: "#3f434a",
                                color: "#fff",
                                fontSize: "14px",
                                maxWidth: 260,
                                padding: "12px 14px",
                                borderRadius: "7px",
                                boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
                              },
                            },
                            arrow: {
                              sx: {
                                color: "#3f434a",
                              },
                            },
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (clickTimer.current) {
                                clearTimeout(clickTimer.current);
                                clickTimer.current = null;
                                handleSelectAll(!job.isChecked);
                              } else {
                                clickTimer.current = setTimeout(() => {
                                  handleCheckboxChange(job, !job.isChecked);
                                  clickTimer.current = null;
                                }, 250);
                              }
                            }}
                            onMouseEnter={() => {
                              if (
                                sessionStorage.getItem("hasSeenSelectAllProjectJobsTip") !== "true" &&
                                tooltipCardId === null
                              ) {
                                setTooltipCardId(job.id);
                                sessionStorage.setItem("hasSeenSelectAllProjectJobsTip", "false");
                              }
                            }}
                          >
                            {job.isChecked ? (
                              <div>
                                <CheckBoxIcon
                                  fontSize="small"
                                  sx={{ color: "var(--primary-bg-color)" }}
                                />
                              </div>
                            ) : (
                              <div className="newCardCheckbox">
                                <CheckBoxOutlineBlankIcon fontSize="small" />
                              </div>
                            )}
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </div>
                    <div className="jobCardBody" onClick={() => handleJobCardClick(job)}>
                      <div className="companyName">
                        {job.clientName ? (
                          job.clientName
                        ) : (
                          <span className="emptyValue">Client : -</span>
                        )}
                      </div>
                      <div className="jobCardDetail">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/assests/img/JobTypeIcon.svg"
                          }
                          alt="Jobtype"
                          width={16}
                          height={16}
                        />
                        <span className="metaLabel">Job Type</span>
                        <span className="metaColon">:</span>
                        <span className="metaValue">{job.jobType || "-"}</span>
                      </div>
                      <div className="jobCardDetail">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/assests/img/LocationIcon.svg"
                          }
                          alt="Location"
                          width={16}
                          height={16}
                        />
                        <span className="metaLabel">Location</span>
                        <span className="metaColon">:</span>
                        <span className="metaValue">{job.location || "—"}</span>
                      </div>
                      <div className="jobCardDetail">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assests/img/WorkModalIcon.svg"
                          }
                          alt="workmodal"
                          width={16}
                          height={16}
                        />
                        <span className="metaLabel">Work Model</span>
                        <span className="metaColon">:</span>
                        <span className="metaValue">{job.workModel || "-"}</span>
                      </div>
                    </div>
                    <div className="jobCardFooter" onClick={() => handleJobCardClick(job)}>
                      <span>
                        {getPostedDaysAgo(job.addedToProjectAt || job.createdAt)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              {jobs.length > CARDS_PER_PAGE && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "20px",
                  }}
                >
                  <Pagination
                    currentPage={currentPage}
                    totalCount={jobs.length}
                    pageSize={CARDS_PER_PAGE}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
              )}
            </>
          ) : (
            /* Empty state - when no data */
            <div className="noJobsFound">
              <img
                src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                alt="No Jobs"
              />
              <p>No Jobs Found</p>
            </div>
          )}

          {/* Add Job to Project - RightSideBar panel */}
          {panelMode === "ADD_JOB" && (
            <div id="addJobToProject" className="rightsidebarbtn">
              <RightSideBar
                componentData={
                  <AddJobPanel
                    projectId={getJobCode}
                    onClose={handleAddPanelClose}
                    associatedJobs={jobs}
                  />
                }
                componentLayout={addJobPanelObj}
                isFooter={false}
                onReceiveProps={handleAddPanelClose}
              />
            </div>
          )}

          {/* Delete confirmation popup for selected jobs */}
          <WarningPopup
            open={deletePopupOpen}
            handleClose={() => setDeletePopupOpen(false)}
            handleConfirm={handleDeleteJob}
            details={{
              title:
                `Are you sure you want to remove job${selectedJobIds.length === 1 ? "" : "s"} from this project?`,
              btnName: "Remove",
            }}
          />
        </>
      ) : (
        <Box className="clientJob-details-container">
          <JobpostingDetailsTabs
            onResetTabs={isResetTabs}
            onReceiveProps={(status, type) => {
              onReceivePropsHandler(status, type);
            }}
            moduleType="projects"
          />
        </Box>
      )}
    </div>
  );
};

// Inner component rendered inside RightSideBar
const AddJobPanel = ({
  projectId,
  onClose,
  associatedJobs = [],
}) => {
  const dispatch = useDispatch();
  const [allJobs, setAllJobs] = useState([]);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [findconfig, setFindconfig] = useState(findconfiguration);
  const [candidateStatusValues, setCandidateStatusValues] = useState([]);
  const [selectedStatusOption, setSelectedStatusOption] = useState("Select");
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [alreadyAssociatedIds, setAlreadyAssociatedIds] = useState([]);

  useEffect(() => {
    if (associatedJobs && associatedJobs.length > 0) {
      setAlreadyAssociatedIds(associatedJobs.map((j) => j.id));
    } else {
      setAlreadyAssociatedIds([]);
    }
  }, [associatedJobs]);

  const responseData = useSelector((state) => state.Listjobpostings.data);
  const addAssociateStatus = useSelector(
    (state) => state.AddAssociateProjectJobs?.data,
  );
  const customFieldsData = useSelector((state) => state.CustomFields?.data);

  useEffect(() => {
    async function init() {
      const userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
    }
    init();
  }, []);

  useEffect(() => {
    let defaultPostingModules = defaultApplicantsData.filter(
      (x) => x.moduleId === "2",
    );
    if (defaultPostingModules.length > 0) {
      defaultPostingModules.forEach((list) => {
        if (list.fieldName === "Candidate status") {
          setCandidateStatusValues(list.customValues || []);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const data = JSON.parse(JSON.stringify(customFieldsData));
      let customStatusFieldsData = data.filter(
        (x) =>
          x.moduleId.toString() === "2" &&
          x.fieldType === "default" &&
          x.fieldName === "Candidate status",
      );
      if (customStatusFieldsData.length > 0) {
        let index = customStatusFieldsData.length - 1;
        let val = customStatusFieldsData[index].customValues;
        let array = typeof val === "string" ? JSON.parse(val) : val;
        setCandidateStatusValues(array);
      }
    }
  }, [customFieldsData]);

  useEffect(() => {
    let obj = { currentPage: 1, keyword: "", limit: 9, offset: 1 };
    dispatch(_props.listjobpostingsAsync(obj, "searchWithPaging"));
  }, []);

  useEffect(() => {
    if (responseData && responseData?.rows?.length > 0) {
      setAllJobs(responseData.rows);
      setFindconfig({ ...findconfig, totalRecords: responseData.total_count });
      dispatch(_props.listjobpostingsStartReducer(initalState));
    } else if (responseData?.rows?.length === 0) {
      setAllJobs([]);
    }
  }, [responseData]);

  useEffect(() => {
    if (addAssociateStatus === 200) {
      dispatch(addAssociateProjectJobsStartReducer(initalState));
      onClose(false, "refresh");
    }
  }, [addAssociateStatus]);

  const onActionHandler = (item, type) => {
    if (type === "searchResult") {
      getListJobs(item);
    } else if (type === "linkNewApplicantToJob") {
      let selected = [...selectedJobs];
      let idx = selected.findIndex((x) => x.id === item?.id);
      if (idx !== -1) {
        selected.splice(idx, 1);
      } else {
        selected.push({
          id: item?.id,
          jobCode: item?.jobCode,
          title: item?.jobTitle,
        });
      }
      setSelectedJobs(selected);
    }
  };

  const getListJobs = (obj) => {
    setAllJobs([]);
    if (obj.keyword) {
      dispatch(_props.listjobpostingsAsync(obj, "searchWithoutPaging"));
    } else {
      dispatch(_props.listjobpostingsAsync(obj, "searchWithPaging"));
    }
  };

  const handleStatusCheckboxChange = (status) => {
    if (selectedStatuses.includes(status)) {
      setSelectedStatuses(selectedStatuses.filter((s) => s !== status));
    } else {
      setSelectedStatuses([...selectedStatuses, status]);
    }
  };

  const footerHandler = (id, type) => {
    if (type === "removeJob") {
      onActionHandler(id, "linkNewApplicantToJob");
    }
    if (type === "Save") {
      if (selectedJobs.length > 0) {
        const payload = {
          projectId: projectId,
          jobIds: selectedJobs.map((j) => j.id),
        };
        dispatch(addAssociateProjectJobsAsync(payload));
      } else {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Please select at least one Job",
          }),
        );
      }
    }
  };

  return (
    <div className="addJobPanelContentt">
      <div className="tabs">
        <div className="findJobsTab">
          <div className="findJobsTabHeader">
            <span>Find Jobs</span>
          </div>
          <hr className="findJobsDivider" />
        </div>
        <div className="mt-5">
          {allJobs ? (
            <AssociateCards
              documentData={[]}
              data={allJobs}
              isAImatched={false}
              selectedItems={selectedJobs}
              searchKeyWord="Search by Job code, Title"
              navigateTo="/ats/layout/jobpostings/view/"
              config={findconfig}
              componentType="AssociatedJobs"
              isAssociate={false}
              onReceiveHandler={(Item, obj) => onActionHandler(Item, obj)}
              alreadyAssociatedIds={alreadyAssociatedIds}
            />
          ) : (
            <div className="nodatasection nodataSection">
              <img
                src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                alt="noResult"
              />
              No Jobs
            </div>
          )}
        </div>
      </div>
      <div className="footer_btn">
        <ApplicantsFooter
          onReceiveProps={footerHandler}
          isEnableAssociateJob={false}
          selectedItems={selectedJobs}
          component={"associateJob"}
        />
      </div>
    </div>
  );
};

export default AddJobsToProjects;

const findconfiguration = {
  recordperPage: 9,
  currentPage: 1,
  totalRecords: 0,
  limitData: 9,
  isSearchServer: true,
};
